const filterdata = (data, searchQuery, fields) => {
  console.log("inside filter data ");
  return data?.filter((user) =>
    fields?.some((field) =>
      user[field]?.toLowerCase().includes(searchQuery?.toLowerCase())
    )
  );
};
export default filterdata;
